// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"d06b7df7","250":"da3fbe75","634":"b097563d","959":"3a305f4b"}[chunkId] + ".chunk.css";
};